import {
    FETCH_PROJECT_LOG,
    FETCH_PROJECT_LOG_ENTRY_THREAD,
    FETCH_PROJECT_LOG_ENTRY_THREAD_ERROR,
    FETCH_PROJECT_LOG_ENTRY_THREAD_SUCCESS,
    FETCH_PROJECT_LOG_ERROR,
    FETCH_PROJECT_LOG_SUCCESS,
    MARK_PROJECT_LOG_ENTRY_READ,
    MARK_PROJECT_LOG_ENTRY_READ_ERROR,
    MARK_PROJECT_LOG_ENTRY_READ_SUCCESS,
    ProjectLogActionsTypes
} from "../../actions/projects/ProjectLogActions";
import {IProjectLogEntry} from "../../models/projects/ProjectLog";
import {
    errorFetchingRequestState,
    RequestState,
    startFetchingRequestState,
    successFetchingRequestState
} from "../../models/common/RequestState";
import {ApiReturnType} from "../../models/common/ApiReturnType";
import {Nullable} from "../../models/common/Nullable";
import {MapByNum} from "../../models/common/Map";

export interface ProjectLogState {
    log: ApiReturnType< IProjectLogEntry[] >
    logByProjectId: MapByNum< ApiReturnType< IProjectLogEntry[] > >,
    threads: {
        [ key: number ]: Nullable< ApiReturnType< IProjectLogEntry[] > >
    }
    request: RequestState
}

const initialState: ProjectLogState = {
    log: { totalEntries: 0, entries: [] },
    logByProjectId: {},
    threads: {},
    request: {
        error: null,
        isFetching: false,
        lastRequestSuccess: 0
    }
};

export const ProjectLogReducer = ( state = initialState, action: ProjectLogActionsTypes ): ProjectLogState => {

    switch( action.type ) {
        case FETCH_PROJECT_LOG:
            return {
                ...state,
                request: {
                    error: null,
                    isFetching: true,
                    lastRequestSuccess: 0
                }
            };
        case FETCH_PROJECT_LOG_ERROR:
            return {
                ...state,
                request: {
                    error: action.error,
                    isFetching: false,
                    lastRequestSuccess: 0
                }
            };
        case FETCH_PROJECT_LOG_SUCCESS:
            if( action.projectIdPath.projectId === null ) {
                return {
                    ...state,
                    log: action.response,
                    request: {
                        ...state.request,
                        isFetching: false,
                        lastRequestSuccess: Date.now()
                    }
                };
            } else {
                return {
                    ...state,
                    logByProjectId: {
                        ...state.logByProjectId,
                        [ action.projectIdPath.projectId.projectId.rawValue ]: action.response
                    },
                    request: {
                        ...state.request,
                        isFetching: false,
                        lastRequestSuccess: Date.now()
                    }
                };
            }
        case FETCH_PROJECT_LOG_ENTRY_THREAD:
            return {
                ...state,
                threads: {
                    [ action.logEntryId ]: null
                },
                request: {
                    ...state.request,
                    isFetching: true,
                    lastRequestSuccess: 0
                }
            };
        case FETCH_PROJECT_LOG_ENTRY_THREAD_ERROR:
            return {
                ...state,
                request: {
                    error: action.error,
                    isFetching: false,
                    lastRequestSuccess: 0
                }
            };
        case FETCH_PROJECT_LOG_ENTRY_THREAD_SUCCESS:
            return {
                ...state,
                threads: {
                    ...state.threads,
                    [ action.logEntryId ]: {
                        totalEntries: action.thread.totalEntries,
                        entries: action.thread.entries
                    }
                },
                request: {
                    ...state.request,
                    isFetching: false,
                    lastRequestSuccess: Date.now()
                }
            };
        case MARK_PROJECT_LOG_ENTRY_READ:
            return {
                ...state,
                request: startFetchingRequestState()
            };
        case MARK_PROJECT_LOG_ENTRY_READ_SUCCESS:
            return {
                ...state,
                request: successFetchingRequestState()
            };
        case MARK_PROJECT_LOG_ENTRY_READ_ERROR:
            return {
                ...state,
                request: errorFetchingRequestState( action.error )
            };
        default:
            return state;
    }

};
